import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RestApiService } from 'src/app/service/rest-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact-isn',
  templateUrl: './contact-isn.component.html',
  styleUrls: ['./contact-isn.component.css']
})
export class ContactisnComponent implements OnInit {
  tabContact: any;
  students: any;

  username: string;
  email: string;
  phone: string;
  objet: string;
  message: string;
  inscriptionForm: FormGroup;
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  submitted = false;
  loader: boolean = false;
  hasPhoneError: boolean;
  isFocus: unknown;
  stepInfo: boolean = false;




  constructor(private route:Router,private rest: RestApiService,
    private angularFirestore: AngularFirestore,private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initForm();
  }


  initForm() {
    this.submitted = false;
    this.inscriptionForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      phone: ['',Validators.required],
      objet: [''],
      message: [''],
    });
  }


  // submitData() {
  //   this.rest.addCountryInforamtion(this.inscriptionForm.value);
  //  }


   submitData() {
    if (this.inscriptionForm.invalid) {
      this.checkValidity(this.inscriptionForm);
      return;
    }
    Swal.fire({
      title: 'Confirmation',
      text: 'Voulez-vous effectuer cette demande',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Valider',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result["value"] == true) {
        this.loader = true;
          this.rest.sendEmail(this.inscriptionForm.value).subscribe((data)=>{
            console.log('data',data);

              this.loader = false;
              this.initForm();
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Votre demande a été envoyée avec succès. Vous serez bientôt contacté par le personnel.',
                showConfirmButton: false,
                timer: 3000
              });
          })
        }
      });
    }


  admissionMaster(type){
    this.route.navigate(['/admissionDetail'], {queryParams:{data:type}})
}


hasError(ev) {
  this.hasPhoneError = !ev ? true : false;
}

getNumber(ev){
  this.inscriptionForm.get('phone').setValue(ev);
}



// getAll() {
//   this.rest.getAllContact().subscribe((data: any) => {
//     this.tabContact = data.map(e => {
//       return {
//         id: e.payload.doc.id,
//         username: e.payload.doc.data()['username'],
//         email: e.payload.doc.data()['email'],
//         phone: e.payload.doc.data()['phone'],
//         objet: e.payload.doc.data()['objet'],
//         message: e.payload.doc.data()['message'],
//       };
//     });
//     console.log(this.tabContact);

//   });
// }


checkValidity(g: FormGroup) {
  Object.keys(g.controls).forEach(key => {
    g.get(key).markAsDirty();
  });
  Object.keys(g.controls).forEach(key => {
    g.get(key).markAsTouched();
  });
  Object.keys(g.controls).forEach(key => {
    g.get(key).updateValueAndValidity();
  });
}









}
